<div class="container">
  <div class="full-fixed">
    <chats-panel></chats-panel>
  </div>
  <div class="contain">
    <chat-window *ngIf="claimedChatsService.getSelectedClaimChat?.chatId"
      [selectedClaimChatId]="claimedChatsService.getSelectedClaimChat?.chatId"></chat-window>
  </div>
</div>
